import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import { faStop } from '@fortawesome/pro-solid-svg-icons/faStop';
import { faStop as faStopLight } from '@fortawesome/pro-light-svg-icons/faStop';

import FontAwesome from 'utils/FA';

const SidebarCalendar = ({
  calendar,
  deselectedSchedules,
  onCalendarToggle,
  onScheduleToggle,
  schedules
}) => {
  const [showSchedules, setShowSchedules] = useState(true);

  return (
    <div className='appointment-list-sidebar-calendar' key={calendar.id}>
      <div className='appointment-list-sidebar-calendar-title'>
        <div className='appointment-list-sidebar-calendar-box'>
          <FontAwesome
            icon={schedules.every((schedule) => deselectedSchedules.includes(schedule.id)) ? faStopLight : faStop}
            fixedWidth
            onClick={useCallback(() => onCalendarToggle(calendar), [deselectedSchedules])}
          />
        </div>

        <div className='appointment-list-sidebar-calendar-name'>
          <a href='#' onClick={useCallback(() => onCalendarToggle(calendar), [deselectedSchedules])}>
            {calendar.name}
          </a>
          <FontAwesome
            icon={showSchedules ? faCaretDown : faCaretRight}
            fixedWidth
            onClick={useCallback(() => setShowSchedules(!showSchedules), [showSchedules])}
          />
        </div>
      </div>

      <div className='appointment-list-sidebar-schedules'>
        {
          showSchedules && schedules.map((schedule) => (
            <a
              className='appointment-list-sidebar-schedule'
              key={schedule.id}
              style={{ color: `#${schedule.background_color}` }}
              href='#'
              onClick={() => onScheduleToggle(schedule)}
            >
              <FontAwesome icon={deselectedSchedules.includes(schedule.id) ? faStopLight : faStop} fixedWidth />
              {schedule.name}
            </a>
          ))
        }
      </div>
    </div>
  );
};

SidebarCalendar.propTypes = {
  /** A list of calendars */
  calendar: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  }),

  /** A list of schedules which have been deselected */
  deselectedSchedules: PropTypes.arrayOf(PropTypes.string),

  /** Method called when toggling the selection of a calendar */
  onCalendarToggle: PropTypes.func,

  /** Method called when toggling the selection of a schedule */
  onScheduleToggle: PropTypes.func,

  /** A list of schedules for this calendar */
  schedules: PropTypes.arrayOf(PropTypes.shape({
    background_color: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string
  }))
};

SidebarCalendar.defaultProps = {
  calendar: {},
  deselectedSchedules: [],
  schedules: [],

  onCalendarToggle: () => false,
  onScheduleToggle: () => false
};

export default SidebarCalendar;
